import { convertToDegrees } from "../../../../services/convertUnits";

export const calculateGradient = (
    range: [number, number],
    vals: [number, number],
    units: string
): [number, number] => {
    if (units != "C") {
        vals = vals.map((v) => Math.round(convertToDegrees(v))) as [
            number,
            number
        ];
    }
    const diff = vals[1] - vals[0];
    const min = 0 - ((vals[0] - range[0]) / diff) * 100;
    const max = 100 + ((range[1] - vals[1]) / diff) * 100;
    return [Math.round(min), Math.round(max)];
};
